import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import LocalStorageItems from "@/constants/LocalStorageNames";

export default function NotLicensedPage() {
  const { t } = useTranslation();

  const logout = () => {
    localStorage.removeItem(LocalStorageItems.addinSession);
    window.location.reload();
  };
  const isLoggedIn = !!localStorage.getItem(LocalStorageItems.addinSession);
  const email = "mail@fairfleet.de";

  return (
    <Container
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-evenly",
      }}
    >
      <Typography variant="h1" sx={{ mt: "-10%" }}>
        😕
      </Typography>
      <Typography variant="h5" sx={{ mt: "-20%", width: "50%" }}>
        {t("notLicensed")}
        <Link href={`mailto:${email}`} underline="hover" color="primary" sx={{ marginLeft: "5px" }}>
          {email}
        </Link>
      </Typography>
      <Box>
        {isLoggedIn && <Button onClick={logout}>{"Logout"}</Button>}
        <Button onClick={() => window.location.reload()}>{"Reload"}</Button>
      </Box>
    </Container>
  );
}
